import React, { Component } from 'react';

export default class Back extends Component {
  render() {
    return <div className="back tile">{this.props.children}</div>;
  }
}
